var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn personPage" }, [
    !_vm.assessment._id
      ? _c("div", [
          _c("p", [
            _vm._v(
              "Lighthouse Indicator not found, or you do not have access to this screening in the given Org/Group context."
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.assessment._id
      ? _c(
          "div",
          [
            _c(
              "b-row",
              { staticClass: "mb-3", attrs: { "align-h": "between" } },
              [
                _c("b-col", { attrs: { cols: "auto" } }, [
                  _c("h4", { staticClass: "card-title mb-0" }, [
                    _vm._v(_vm._s(_vm.assessment.id))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted" }, [
                    _vm._v(
                      "Added " +
                        _vm._s(_vm.$utils.formatDate(_vm.assessment.timestamp))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "auto" } },
                  [
                    _vm.isAllowedToCreateOrEditPerson
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/screening/" + _vm.assessment.id + "/edit"
                            }
                          },
                          [
                            _c("b-button", { staticClass: "mx-0" }, [
                              _vm._v("Edit")
                            ])
                          ],
                          1
                        )
                      : _c(
                          "b-button",
                          { staticClass: "mx-0", attrs: { disabled: "" } },
                          [_vm._v("Edit")]
                        )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { sm: "9" } },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("b-card-header", [
                          _c("strong", [_vm._v("Physical Indicators")]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "switch switch-sm switch-text infoActiveToggle switch-danger mb-0 pull-right"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.physicalFilter,
                                    expression: "physicalFilter"
                                  }
                                ],
                                staticClass: "switch-input",
                                attrs: {
                                  id: "positive_switch",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.physicalFilter)
                                    ? _vm._i(_vm.physicalFilter, null) > -1
                                    : _vm.physicalFilter
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.physicalFilter,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.physicalFilter = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.physicalFilter = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.physicalFilter = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "switch-label",
                                attrs: { "data-on": "Yes", "data-off": "All" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "switch-handle" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-row",
                              _vm._l(_vm.getFields("physical"), function(
                                field,
                                key
                              ) {
                                return _c(
                                  "b-col",
                                  { key: key, attrs: { sm: "6", lg: "6" } },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          "bg-variant":
                                            _vm.assessment[field.name] === "Yes"
                                              ? "danger"
                                              : "default"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(field.label))]
                                        ),
                                        _vm._v(" "),
                                        _vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.assessment[field.name]
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [_vm._v("No Answer")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    false
                      ? _c(
                          "b-card",
                          { attrs: { "no-body": true } },
                          [
                            _c("b-card-header", [
                              _c("strong", [_vm._v("Physical Indicators")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      _vm._l(
                                        _vm.getFields("physical"),
                                        function(field, key) {
                                          return _c(
                                            "b-list-group",
                                            { key: key },
                                            [
                                              _c(
                                                "b-list-group-item",
                                                {
                                                  attrs: {
                                                    variant:
                                                      _vm.assessment[
                                                        field.name
                                                      ] === "Yes"
                                                        ? "danger"
                                                        : "light"
                                                  }
                                                },
                                                [_vm._v(_vm._s(field.label))]
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("b-card-header", [
                          _c("strong", [_vm._v("Behavioral Indicators")]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "switch switch-sm switch-text infoActiveToggle switch-danger mb-0 pull-right"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.behavioralFilter,
                                    expression: "behavioralFilter"
                                  }
                                ],
                                staticClass: "switch-input",
                                attrs: {
                                  id: "positive_switch_2",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.behavioralFilter)
                                    ? _vm._i(_vm.behavioralFilter, null) > -1
                                    : _vm.behavioralFilter
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.behavioralFilter,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.behavioralFilter = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.behavioralFilter = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.behavioralFilter = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "switch-label",
                                attrs: { "data-on": "Yes", "data-off": "All" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "switch-handle" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-row",
                              _vm._l(_vm.getFields("behavioral"), function(
                                field
                              ) {
                                return _c(
                                  "b-col",
                                  {
                                    key: field.name,
                                    attrs: { sm: "6", lg: "6" }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          "bg-variant":
                                            _vm.assessment[field.name] === "Yes"
                                              ? "danger"
                                              : "default"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(field.label))]
                                        ),
                                        _vm._v(" "),
                                        _vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.assessment[field.name]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [_vm._v(" No Answer ")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("b-card-header", [
                          _c("strong", [_vm._v("Psychological Indicators")]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "switch switch-sm switch-text infoActiveToggle switch-danger mb-0 pull-right"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.psychologicalFilter,
                                    expression: "psychologicalFilter"
                                  }
                                ],
                                staticClass: "switch-input",
                                attrs: {
                                  id: "positive_switch_2",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.psychologicalFilter
                                  )
                                    ? _vm._i(_vm.psychologicalFilter, null) > -1
                                    : _vm.psychologicalFilter
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.psychologicalFilter,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.psychologicalFilter = $$a.concat(
                                            [$$v]
                                          ))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.psychologicalFilter = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.psychologicalFilter = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "switch-label",
                                attrs: { "data-on": "Yes", "data-off": "All" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "switch-handle" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-row",
                              _vm._l(_vm.getFields("psychological"), function(
                                field
                              ) {
                                return _c(
                                  "b-col",
                                  {
                                    key: field.name,
                                    attrs: { sm: "6", lg: "6" }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          "bg-variant":
                                            _vm.assessment[field.name] === "Yes"
                                              ? "danger"
                                              : "default"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(field.label))]
                                        ),
                                        _vm._v(" "),
                                        _vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.assessment[field.name]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [_vm._v(" No Answer ")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("b-card-header", [
                          _c("strong", [_vm._v("Medical Indicators")]),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "switch switch-sm switch-text infoActiveToggle switch-danger mb-0 pull-right"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.medicalFilter,
                                    expression: "medicalFilter"
                                  }
                                ],
                                staticClass: "switch-input",
                                attrs: {
                                  id: "positive_switch_3",
                                  type: "checkbox"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.medicalFilter)
                                    ? _vm._i(_vm.medicalFilter, null) > -1
                                    : _vm.medicalFilter
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.medicalFilter,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.medicalFilter = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.medicalFilter = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.medicalFilter = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "switch-label",
                                attrs: { "data-on": "Yes", "data-off": "All" }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "switch-handle" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-row",
                              _vm._l(_vm.getFields("medical"), function(field) {
                                return _c(
                                  "b-col",
                                  {
                                    key: field.name,
                                    attrs: { sm: "6", lg: "6" }
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: {
                                          "bg-variant":
                                            _vm.assessment[field.name] === "Yes"
                                              ? "danger"
                                              : "default"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ]
                                          },
                                          [_vm._v(_vm._s(field.label))]
                                        ),
                                        _vm._v(" "),
                                        _vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.assessment[field.name]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.assessment[field.name]
                                          ? _c(
                                              "div",
                                              { staticClass: "h4 m-0" },
                                              [_vm._v(" No Answer ")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c("b-card-header", [
                          _c("strong", [_vm._v("Follow-up Questions")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-card-body",
                          [
                            _vm.assessment.q_safe
                              ? _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "12" } },
                                      [
                                        _c(
                                          "b-card",
                                          {
                                            attrs: {
                                              "border-variant": "default"
                                            }
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "4" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "questionlabel"
                                                      },
                                                      [_vm._v("Are you safe?")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "h4 m-0" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .q_safe
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-col",
                                                  { attrs: { lg: "8" } },
                                                  [
                                                    _vm.assessment.d_safe
                                                      ? _c(
                                                          "h6",
                                                          {
                                                            staticClass:
                                                              "questionlabelsm"
                                                          },
                                                          [_vm._v("Details")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.assessment.d_safe
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "p mt-2 preserve-whitespace"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.assessment
                                                                    .d_safe
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.assessment.q_doctor
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Do you want to see a doctor?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_doctor
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_doctor
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_doctor
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_doctor
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.q_anybody
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Are you with anybody?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_anybody
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_anybody
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_anybody
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_anybody
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.q_finding
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Are you worried about someone finding you?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_finding
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_finding
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_finding
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_finding
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.q_someone
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Do you wish someone else was taking care of you?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_someone
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_someone
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_someone
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_someone
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.q_do_something
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Has anyone made you do something you did not want to do or made you uncomfortable?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_do_something
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_do_something
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_do_something
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_do_something
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.q_bullied
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Have you been bullied?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "h4 m-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.assessment
                                                            .q_bullied
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "8" } },
                                              [
                                                _vm.assessment.d_bullied
                                                  ? _c(
                                                      "h6",
                                                      {
                                                        staticClass:
                                                          "questionlabelsm"
                                                      },
                                                      [_vm._v("Details")]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.assessment.d_bullied
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "p mt-2 preserve-whitespace"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_bullied
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.d_basic_needs
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "How do you get your basic needs met?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.assessment.d_basic_needs
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "p mt-2" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_basic_needs
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.d_school
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Tell me about school"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.assessment.d_school
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "p mt-2" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_school
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.d_worst_hurt
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "What is the worst you have ever been hurt by someone else?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.assessment.d_worst_hurt
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "p mt-2" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_worst_hurt
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.assessment.d_hang_out
                          ? _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        attrs: { "border-variant": "default" }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "questionlabel"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Who do you hang out with?"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.assessment.d_hang_out
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "p mt-2" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.assessment
                                                                .d_hang_out
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { sm: "3" } },
                  [
                    _c("ShareAssessmentList", {
                      attrs: {
                        personId: _vm.assessment.person._id,
                        assessmentId: _vm.assessment._id,
                        assessmentOrganizationOwner:
                          _vm.assessment.organizationOwner.id
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      {
                        attrs: {
                          "bg-variant":
                            _vm.assessment.dmst_conclusion === "Yes"
                              ? "danger"
                              : "default"
                        }
                      },
                      [
                        _c("div", [_vm._v("Lighthouse Indicators Conclusion")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "h4 m-0" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.assessment.dmst_conclusion === "Yes"
                                  ? "Possible Trafficking Victim"
                                  : "Not Enough Information"
                              ) +
                              " "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { attrs: { "no-body": "", title: _vm.assessment.id } },
                      [
                        _c("b-card-body", [
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("Person ID")]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "small",
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: "/person/" + _vm.assessment.person_id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.assessment.person_id) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("First Recorded")]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _c("b", [_vm._v(" on: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getCreatedAt()) +
                                  "\n                  "
                              ),
                              _vm._.isObject(_vm.assessment.createdBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.assessment,
                                            "createdBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("Last Updated")]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _c("b", [_vm._v(" on: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getLastUpdateDate()) +
                                  "\n                  "
                              ),
                              _vm._.isObject(_vm.assessment.updatedBy)
                                ? _c("div", [
                                    _c("b", [_vm._v(" by: ")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.assessment,
                                            "updatedBy.emailAddress",
                                            ""
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "card-text" }, [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "text-muted text-uppercase font-weight-bold"
                              },
                              [_vm._v("Current Record Owner")]
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _c("b", [_vm._v(" by: ")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.assessment,
                                      "organizationOwner.title"
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._.isObject(_vm.assessment.location)
                      ? _c("b-card", [
                          _c("div", [_vm._v("Location")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "h4 m-0" }, [
                            _vm._v(_vm._s(_vm.assessment.location.title))
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._.isObject(_vm.assessment.program)
                      ? _c("b-card", [
                          _c("div", [_vm._v("Program")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "h4 m-0" }, [
                            _vm._v(
                              _vm._s(
                                _vm.assessment.program.title !== "Other"
                                  ? _vm.assessment.program.title
                                  : _vm.assessment.program.title_otherText
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b387276c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b387276c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Assessment.vue
// module id = 1650
// module chunks = 0